import classNames from 'classnames'
import type { FunctionalComponent, HTMLAttributes } from 'vue'
import './PositionInfo.layout.scss'

export const PositionInfoLayout: FunctionalComponent<HTMLAttributes> = (_props, { slots, attrs }) => {
  return (
    <div {...attrs} class={classNames('position-info-layout', attrs.class as string)}>
      {slots.default?.()}
    </div>
  )
}
PositionInfoLayout.inheritAttrs = false

export const PositionItemLayout: FunctionalComponent<HTMLAttributes> = (_props, { slots, attrs }) => {
  return (
    <div {...attrs} class={classNames('position-item-layout', attrs.class as string)}>
      {slots.default?.()}
    </div>
  )
}
PositionItemLayout.inheritAttrs = false
